import { jsx as _jsx } from "react/jsx-runtime";
import { Link } from "../../link";
import { MetaNavigationListItem } from "./MetaNavigationItem.styles";
export const MetaNavigationItem = ({ title, target, className, onClick, }) => (_jsx(MetaNavigationListItem, { children: _jsx(Link, { href: target, standardFontSize: true, stylingType: "secondary", hasArrow: false, target: target, text: title, disabled: false, className: className, onClick: onClick }) }));
